import * as a from "three";
import { CLICK_DISTANCE_THRESHOLD_PX as oe, measureDistance as be, ORIGIN_SNAP_RADIUS_PX as we, DOUBLE_CLICK_MS as xe, DOUBLE_CLICK_DISTANCE_PX as Ee, measureArea as Ae, measurePerimeter as Le, polygonSelfIntersects as Me, ANGLE_ARC_SEGMENTS_PER_TURN as ue, measureDirectedAngle as fe, toDegrees as Ce, ANGLE_ARC_RADIUS_FRACTION as Pe, ANGLE_ARC_MIN_PX as De, ANGLE_ARC_MAX_PX as Se, findSnapPoint as Re, SNAP_OVERLAY_RENDER_ORDER as de, SNAP_TOLERANCE_PX as ke, SNAP_MARKER_PX as Be, findEntriesInRect as Te, extractEntityText as pe, buildPickingIndex as Ie, buildEntityIndex as Ne, buildAssociations as Oe, createPickingGroup as Ge, disposePickingGroup as Xe, setPickingGroupDebug as Fe, buildHighlightGeometry as _e } from "dxf-render";
const ye = { x: 0, y: 0 };
function ne(r, e, t, o, u) {
  const c = (r - t.left) / t.width * 2 - 1, h = -((e - t.top) / t.height) * 2 + 1, y = new a.Vector3(c, h, 0).unproject(o);
  return { x: y.x + u.x, y: y.y + u.y, z: 0 };
}
function Ye(r, e, t, o) {
  const u = new a.Vector3(r.x - o.x, r.y - o.y, 0).project(t);
  return {
    x: e.left + (u.x + 1) / 2 * e.width,
    y: e.top + (-u.y + 1) / 2 * e.height
  };
}
function ze(r, e) {
  if (r.width === 0) return 1;
  const t = r.left + r.width / 2, o = r.top + r.height / 2, u = ne(t, o, r, e, ye), c = ne(t + 1, o, r, e, ye), h = Math.hypot(c.x - u.x, c.y - u.y);
  return h > 0 ? h : 1;
}
function j(r, e) {
  let t = r.getAttribute("position");
  if (!t || t.array.length < e * 3) {
    const o = new Float32Array(Math.max(e, 4) * 3);
    t = new a.BufferAttribute(o, 3), r.setAttribute("position", t);
  }
  return t.array;
}
function We(r, e) {
  return Math.hypot(r, e) >= oe;
}
function re(r) {
  if (!(r instanceof HTMLElement)) return !1;
  const e = r.tagName;
  return e === "INPUT" || e === "TEXTAREA" || e === "SELECT" || r.isContentEditable;
}
function se() {
  let r = !1, e = null, t = null, o = null, u = null, c = null, h = () => ({ x: 0, y: 0, z: 0 }), y = null, p = {}, D = "#ff6b1a", P, w = null, R = 0, N = 0, C = -1;
  const m = (v) => {
    t && (t.style.cursor = v ? "crosshair" : "");
  }, l = (v, F) => !t || !u ? null : ne(
    v,
    F,
    t.getBoundingClientRect(),
    u,
    h()
  ), x = (v) => !t || !u ? null : Ye(v, t.getBoundingClientRect(), u, h()), s = () => !t || !u ? 1 : ze(t.getBoundingClientRect(), u), f = (v, F, b) => p.snap ? p.snap(v, F, b) : v, g = () => {
    y?.();
  }, k = () => {
    !o || w || (w = new a.Group(), w.name = e?.overlayName ?? "dxf-pointer-tool-overlay", w.renderOrder = 999, o.add(w), e?.buildOverlay(w, D));
  }, M = () => {
    !o || !w || (o.remove(w), e?.disposeOverlay(), w = null);
  }, B = () => {
    !c || P !== void 0 || (P = c.mouseButtons.LEFT, c.mouseButtons.LEFT = null);
  }, O = () => {
    !c || P === void 0 || (c.mouseButtons.LEFT = P, P = void 0);
  }, i = (v) => {
    if (r) {
      if (v.button !== 0) {
        v.preventDefault();
        return;
      }
      R = v.clientX, N = v.clientY, C = v.button;
    }
  }, d = (v) => {
    if (!r || C !== 0 || (C = -1, We(v.clientX - R, v.clientY - N))) return;
    const F = l(v.clientX, v.clientY);
    F && (v.stopPropagation(), e?.onCommit(F, v));
  }, I = (v) => {
    if (!r) return;
    const F = l(v.clientX, v.clientY);
    if (!F) return;
    const b = f(F, v.clientX, v.clientY);
    e?.onMove(b, v);
  }, A = (v) => {
    r && e?.onKeyDown?.(v);
  }, S = (v, F, b, n, E, L, G) => {
    T(), t = v, o = F, u = b, c = n, h = E, y = L, p = G ?? {}, t.addEventListener("pointerdown", i, { capture: !0 }), t.addEventListener("pointerup", d, { capture: !0 }), t.addEventListener("pointermove", I), e?.onAttach?.(t), window.addEventListener("keydown", A);
  }, T = () => {
    t && (t.removeEventListener("pointerdown", i, {
      capture: !0
    }), t.removeEventListener("pointerup", d, {
      capture: !0
    }), t.removeEventListener("pointermove", I), e?.onDetach?.(t), m(!1)), window.removeEventListener("keydown", A), O(), t = null, u = null, o = null, c = null, p = {}, y = null, r = !1;
  };
  return {
    isActive: () => r,
    configure(v) {
      e = v;
    },
    attach: S,
    detach: T,
    setEnabled: (v) => {
      r !== v && (r = v, m(v), v ? (k(), B()) : (O(), e?.reset(!0)));
    },
    setColor: (v) => {
      D = v, e?.applyColor(v), g();
    },
    dispose: () => {
      T(), M();
    },
    ensureOverlay: k,
    screenToWorld: l,
    worldToScreen: x,
    worldPerPixel: s,
    applySnap: f,
    getOffset: () => h(),
    getCallbacks: () => p,
    render: g
  };
}
function tt(r) {
  const e = { current: { points: [], hoverWorld: null } }, t = se();
  let o = 1, u = "dxf-units", c = null, h = null, y = null, p = null;
  const D = () => {
    if (t.ensureOverlay(), !y || !p) return;
    const m = t.getOffset(), l = e.current.points, x = l.length === 1 ? e.current.hoverWorld : null, s = p.geometry.getAttribute("position"), f = s.array;
    if (l.length === 0)
      p.visible = !1, p.geometry.setDrawRange(0, 0);
    else {
      for (let M = 0; M < l.length; M++)
        f[M * 3 + 0] = l[M].x - m.x, f[M * 3 + 1] = l[M].y - m.y, f[M * 3 + 2] = 0;
      s.needsUpdate = !0, p.geometry.setDrawRange(0, l.length), p.visible = !0;
    }
    const g = l[0], k = l[1] ?? x ?? null;
    if (g && k) {
      const M = y.geometry.getAttribute("position"), B = M.array;
      B[0] = g.x - m.x, B[1] = g.y - m.y, B[2] = 0, B[3] = k.x - m.x, B[4] = k.y - m.y, B[5] = 0, M.needsUpdate = !0, y.geometry.computeBoundingSphere(), y.visible = !0;
    } else
      y.visible = !1;
  }, P = () => {
    t.getCallbacks().onChange?.(e.current), D(), t.render(), r(e.current);
  }, w = (m) => {
    const l = e.current.points.length > 0;
    e.current = { points: [], hoverWorld: null }, P(), m && l && t.getCallbacks().onCancel?.();
  }, R = (m) => {
    const l = e.current.points;
    if (l.length === 0) {
      e.current = { points: [m], hoverWorld: m }, P();
      return;
    }
    if (l.length === 1) {
      const x = l[0], s = m, f = be(x, s);
      e.current = { points: [x, s], hoverWorld: null }, P(), t.getCallbacks().onResult?.({
        kind: "distance",
        p1: x,
        p2: s,
        valueRaw: f,
        value: f * o,
        units: u
      });
      return;
    }
    e.current = { points: [m], hoverWorld: m }, P();
  };
  t.configure({
    overlayName: "dxf-measurement-overlay",
    buildOverlay: (m, l) => {
      c = new a.LineBasicMaterial({
        color: new a.Color(l),
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 0.95
      }), h = new a.PointsMaterial({
        color: new a.Color(l),
        size: 8,
        sizeAttenuation: !1,
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 1
      });
      const x = new a.BufferGeometry();
      x.setAttribute("position", new a.BufferAttribute(new Float32Array(6), 3)), y = new a.Line(x, c), y.visible = !1, m.add(y);
      const s = new a.BufferGeometry();
      s.setAttribute("position", new a.BufferAttribute(new Float32Array(6), 3)), s.setDrawRange(0, 0), p = new a.Points(s, h), p.visible = !1, m.add(p);
    },
    disposeOverlay: () => {
      y?.geometry.dispose(), p?.geometry.dispose(), c?.dispose(), h?.dispose(), y = null, p = null, c = null, h = null;
    },
    applyColor: (m) => {
      c?.color.set(m), h?.color.set(m);
    },
    onCommit: (m, l) => {
      R(t.applySnap(m, l.clientX, l.clientY));
    },
    onMove: (m) => {
      e.current.points.length === 1 && (e.current = { points: e.current.points, hoverWorld: m }, P());
    },
    onKeyDown: (m) => {
      m.key === "Escape" && (e.current.points.length > 0 && (m.preventDefault(), m.stopPropagation()), w(!0));
    },
    reset: w
  });
  const N = (m, l) => {
    o = m, u = l;
  }, C = () => {
    e.current = { points: [], hoverWorld: null }, P();
  };
  return {
    tool: t,
    attach: t.attach,
    detach: t.detach,
    setEnabled: t.setEnabled,
    setUnitsScale: N,
    setColor: t.setColor,
    clear: C,
    dispose: t.dispose
  };
}
function nt(r, e) {
  if (!Number.isFinite(r)) return "—";
  const o = Math.abs(r) >= 100 ? r.toFixed(1) : r.toFixed(2);
  return e === "mm" ? `${o} mm` : e === "inch" ? `${o} in` : o;
}
const J = () => ({
  points: [],
  hoverWorld: null,
  closed: !1,
  originSnap: !1
});
function rt(r) {
  const e = { current: J() }, t = se();
  let o = { areaScale: 1, perimeterScale: 1, areaLabel: "", lengthLabel: "" }, u = null, c = null, h = null, y = null, p = null, D = null, P = null, w = null, R = 0, N = 0, C = 0;
  const m = () => {
    const i = e.current;
    return i.closed ? i.points : i.hoverWorld ? [...i.points, i.hoverWorld] : i.points;
  }, l = () => {
    if (t.ensureOverlay(), !p || !D || !P || !w) return;
    const i = t.getOffset(), d = e.current.points, I = m();
    if (I.length >= 2) {
      const A = j(p.geometry, I.length);
      for (let T = 0; T < I.length; T++)
        A[T * 3] = I[T].x - i.x, A[T * 3 + 1] = I[T].y - i.y, A[T * 3 + 2] = 0;
      const S = p.geometry.getAttribute("position");
      S.needsUpdate = !0, p.geometry.setDrawRange(0, I.length), p.geometry.computeBoundingSphere(), p.visible = !0;
    } else
      p.visible = !1;
    if (I.length >= 3) {
      const A = I.map((T) => new a.Vector2(T.x - i.x, T.y - i.y));
      let S = [];
      try {
        S = a.ShapeUtils.triangulateShape(A, []);
      } catch {
        S = [];
      }
      if (S.length > 0) {
        const T = new Float32Array(A.length * 3);
        for (let X = 0; X < A.length; X++)
          T[X * 3] = A[X].x, T[X * 3 + 1] = A[X].y, T[X * 3 + 2] = 0;
        const Y = new Uint16Array(S.length * 3);
        for (let X = 0; X < S.length; X++)
          Y[X * 3] = S[X][0], Y[X * 3 + 1] = S[X][1], Y[X * 3 + 2] = S[X][2];
        D.geometry.setAttribute("position", new a.BufferAttribute(T, 3)), D.geometry.setIndex(new a.BufferAttribute(Y, 1)), D.geometry.computeBoundingSphere(), D.visible = !0;
      } else
        D.visible = !1;
    } else
      D.visible = !1;
    if (d.length >= 1) {
      const A = j(P.geometry, d.length);
      for (let T = 0; T < d.length; T++)
        A[T * 3] = d[T].x - i.x, A[T * 3 + 1] = d[T].y - i.y, A[T * 3 + 2] = 0;
      const S = P.geometry.getAttribute("position");
      S.needsUpdate = !0, P.geometry.setDrawRange(0, d.length), P.visible = !0;
    } else
      P.visible = !1;
    if (e.current.originSnap && d.length >= 1) {
      const A = w.geometry.getAttribute("position"), S = A.array;
      S[0] = d[0].x - i.x, S[1] = d[0].y - i.y, S[2] = 0, A.needsUpdate = !0, w.geometry.setDrawRange(0, 1), w.visible = !0;
    } else
      w.visible = !1;
  }, x = () => {
    t.getCallbacks().onChange?.(e.current), l(), t.render(), r(e.current);
  }, s = (i) => {
    const d = e.current.points.length > 0;
    e.current = J(), x(), i && d && t.getCallbacks().onCancel?.();
  }, f = () => {
    const i = e.current.points;
    if (i.length < 3) return;
    e.current = { points: i, hoverWorld: null, closed: !0, originSnap: !1 }, x();
    const d = Ae(i), I = Le(i);
    t.getCallbacks().onResult?.({
      points: i.map((A) => ({ x: A.x, y: A.y, z: A.z ?? 0 })),
      areaRaw: d,
      area: d * o.areaScale,
      perimeterRaw: I,
      perimeter: I * o.perimeterScale,
      areaUnits: o.areaLabel,
      lengthUnits: o.lengthLabel,
      selfIntersecting: Me(i)
    });
  }, g = (i) => {
    e.current.closed ? e.current = { points: [i], hoverWorld: i, closed: !1, originSnap: !1 } : e.current = {
      points: [...e.current.points, i],
      hoverWorld: i,
      closed: !1,
      originSnap: !1
    }, x();
  }, k = () => {
    if (e.current.closed || e.current.points.length === 0) return;
    const i = e.current.points.slice(0, -1);
    e.current = {
      points: i,
      hoverWorld: e.current.hoverWorld,
      closed: !1,
      originSnap: !1
    }, x();
  }, M = (i) => {
    t.isActive() && i.preventDefault();
  };
  t.configure({
    overlayName: "dxf-area-measurement-overlay",
    buildOverlay: (i, d) => {
      const I = new a.Color(d);
      c = new a.MeshBasicMaterial({
        color: I.clone(),
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 0.2,
        side: a.DoubleSide
      }), u = new a.LineBasicMaterial({
        color: I.clone(),
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 0.95
      }), h = new a.PointsMaterial({
        color: I.clone(),
        size: 8,
        sizeAttenuation: !1,
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 1
      }), y = new a.PointsMaterial({
        color: I.clone(),
        size: 16,
        sizeAttenuation: !1,
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 0.6
      }), D = new a.Mesh(new a.BufferGeometry(), c), D.visible = !1, i.add(D);
      const A = new a.BufferGeometry();
      A.setAttribute("position", new a.BufferAttribute(new Float32Array(12), 3)), A.setDrawRange(0, 0), p = new a.LineLoop(A, u), p.visible = !1, i.add(p);
      const S = new a.BufferGeometry();
      S.setAttribute("position", new a.BufferAttribute(new Float32Array(12), 3)), S.setDrawRange(0, 0), P = new a.Points(S, h), P.visible = !1, i.add(P);
      const T = new a.BufferGeometry();
      T.setAttribute("position", new a.BufferAttribute(new Float32Array(3), 3)), T.setDrawRange(0, 0), w = new a.Points(T, y), w.visible = !1, i.add(w);
    },
    disposeOverlay: () => {
      p?.geometry.dispose(), D?.geometry.dispose(), P?.geometry.dispose(), w?.geometry.dispose(), u?.dispose(), c?.dispose(), h?.dispose(), y?.dispose(), p = null, D = null, P = null, w = null, u = null, c = null, h = null, y = null;
    },
    applyColor: (i) => {
      const d = new a.Color(i);
      u?.color.set(d), c?.color.set(d), h?.color.set(d), y?.color.set(d);
    },
    onCommit: (i, d) => {
      const I = performance.now(), A = I - R < xe && Math.hypot(d.clientX - N, d.clientY - C) < Ee;
      if (!e.current.closed) {
        if (A && e.current.points.length >= 3) {
          f();
          return;
        }
        if (e.current.originSnap && e.current.points.length >= 3) {
          f();
          return;
        }
      }
      const S = t.applySnap(i, d.clientX, d.clientY);
      g(S), R = I, N = d.clientX, C = d.clientY;
    },
    onMove: (i, d) => {
      if (e.current.closed) return;
      const I = e.current.points;
      if (I.length < 1) return;
      let A = !1;
      if (I.length >= 3) {
        const S = t.worldToScreen(I[0]);
        S && (A = Math.hypot(d.clientX - S.x, d.clientY - S.y) <= we);
      }
      e.current = { points: I, hoverWorld: i, closed: !1, originSnap: A }, x();
    },
    onKeyDown: (i) => {
      if (i.key === "Escape") {
        (e.current.points.length > 0 || e.current.closed) && (i.preventDefault(), i.stopPropagation()), s(!0);
        return;
      }
      if (i.key === "Enter") {
        if (re(i.target)) return;
        !e.current.closed && e.current.points.length >= 3 && (i.preventDefault(), f());
        return;
      }
      if (i.key === "Backspace") {
        if (re(i.target)) return;
        !e.current.closed && e.current.points.length >= 1 && (i.preventDefault(), k());
      }
    },
    reset: s,
    onAttach: (i) => {
      i.addEventListener("dblclick", M, { capture: !0 });
    },
    onDetach: (i) => {
      i.removeEventListener("dblclick", M, {
        capture: !0
      });
    }
  });
  const B = (i) => {
    o = i;
  }, O = () => {
    e.current = J(), x();
  };
  return {
    attach: t.attach,
    detach: t.detach,
    setEnabled: t.setEnabled,
    setUnits: B,
    setColor: t.setColor,
    clear: O,
    dispose: t.dispose
  };
}
function ot(r, e) {
  if (!Number.isFinite(r)) return "—";
  const o = Math.abs(r) >= 100 ? r.toFixed(1) : r.toFixed(2);
  return e ? `${o} ${e}` : o;
}
const ee = () => ({
  points: [],
  hoverWorld: null,
  closed: !1
});
function st(r) {
  const e = { current: ee() }, t = se();
  let o = "deg", u = null, c = null, h = null, y = null, p = null;
  const D = () => {
    const s = e.current, f = s.points;
    return f.length === 1 ? { vertex: f[0], r1: s.closed ? null : s.hoverWorld, r2: null } : f.length === 2 ? { vertex: f[0], r1: f[1], r2: s.closed ? null : s.hoverWorld } : f.length >= 3 ? { vertex: f[0], r1: f[1], r2: f[2] } : { vertex: null, r1: null, r2: null };
  }, P = () => {
    if (t.ensureOverlay(), !h || !y || !p) return;
    const s = t.getOffset(), f = e.current.points, { vertex: g, r1: k, r2: M } = D(), B = [];
    if (g && (k && B.push(k), B.push(g), M && B.push(M)), B.length >= 2) {
      const O = j(h.geometry, B.length);
      for (let d = 0; d < B.length; d++)
        O[d * 3] = B[d].x - s.x, O[d * 3 + 1] = B[d].y - s.y, O[d * 3 + 2] = 0;
      const i = h.geometry.getAttribute("position");
      i.needsUpdate = !0, h.geometry.setDrawRange(0, B.length), h.geometry.computeBoundingSphere(), h.visible = !0;
    } else
      h.visible = !1;
    if (g && k && M) {
      const O = Math.hypot(k.x - g.x, k.y - g.y), i = Math.hypot(M.x - g.x, M.y - g.y), d = Math.min(O, i), I = fe(g, k, M);
      if (d > 0 && I > 0) {
        const A = t.worldPerPixel();
        let S = Pe * d;
        S = Math.max(De * A, Math.min(S, Se * A)), S = Math.min(S, d * 0.9);
        const T = Math.atan2(k.y - g.y, k.x - g.x), Y = Math.max(2, Math.ceil(I / (Math.PI * 2) * ue)), X = j(y.geometry, Y + 1);
        for (let v = 0; v <= Y; v++) {
          const F = T + I * (v / Y);
          X[v * 3] = g.x + S * Math.cos(F) - s.x, X[v * 3 + 1] = g.y + S * Math.sin(F) - s.y, X[v * 3 + 2] = 0;
        }
        const W = y.geometry.getAttribute("position");
        W.needsUpdate = !0, y.geometry.setDrawRange(0, Y + 1), y.geometry.computeBoundingSphere(), y.visible = !0;
      } else
        y.visible = !1;
    } else
      y.visible = !1;
    if (f.length >= 1) {
      const O = j(p.geometry, f.length);
      for (let d = 0; d < f.length; d++)
        O[d * 3] = f[d].x - s.x, O[d * 3 + 1] = f[d].y - s.y, O[d * 3 + 2] = 0;
      const i = p.geometry.getAttribute("position");
      i.needsUpdate = !0, p.geometry.setDrawRange(0, f.length), p.visible = !0;
    } else
      p.visible = !1;
  }, w = () => {
    t.getCallbacks().onChange?.(e.current), P(), t.render(), r(e.current);
  }, R = (s) => {
    const f = e.current.points.length > 0 && !e.current.closed;
    e.current = ee(), w(), s && f && t.getCallbacks().onCancel?.();
  }, N = () => {
    const s = e.current.points;
    if (s.length < 3) return;
    e.current = { points: s, hoverWorld: null, closed: !0 }, w();
    const [f, g, k] = s, M = fe(f, g, k), B = Ce(M);
    t.getCallbacks().onResult?.({
      vertex: { x: f.x, y: f.y, z: f.z ?? 0 },
      p1: { x: g.x, y: g.y, z: g.z ?? 0 },
      p2: { x: k.x, y: k.y, z: k.z ?? 0 },
      radians: M,
      degrees: B,
      reflex: B > 180,
      units: o
    });
  }, C = (s) => {
    e.current = {
      points: [...e.current.points, s],
      hoverWorld: s,
      closed: !1
    }, w();
  }, m = () => {
    if (e.current.closed || e.current.points.length === 0) return;
    const s = e.current.points.slice(0, -1);
    e.current = { points: s, hoverWorld: e.current.hoverWorld, closed: !1 }, w();
  };
  t.configure({
    overlayName: "dxf-angle-measurement-overlay",
    buildOverlay: (s, f) => {
      const g = new a.Color(f);
      u = new a.LineBasicMaterial({
        color: g.clone(),
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 0.95
      }), c = new a.PointsMaterial({
        color: g.clone(),
        size: 8,
        sizeAttenuation: !1,
        depthTest: !1,
        depthWrite: !1,
        transparent: !0,
        opacity: 1
      });
      const k = new a.BufferGeometry();
      k.setAttribute("position", new a.BufferAttribute(new Float32Array(9), 3)), k.setDrawRange(0, 0), h = new a.Line(k, u), h.visible = !1, s.add(h);
      const M = new a.BufferGeometry();
      M.setAttribute(
        "position",
        new a.BufferAttribute(new Float32Array((ue + 1) * 3), 3)
      ), M.setDrawRange(0, 0), y = new a.Line(M, u), y.visible = !1, s.add(y);
      const B = new a.BufferGeometry();
      B.setAttribute("position", new a.BufferAttribute(new Float32Array(9), 3)), B.setDrawRange(0, 0), p = new a.Points(B, c), p.visible = !1, s.add(p);
    },
    disposeOverlay: () => {
      h?.geometry.dispose(), y?.geometry.dispose(), p?.geometry.dispose(), u?.dispose(), c?.dispose(), h = null, y = null, p = null, u = null, c = null;
    },
    applyColor: (s) => {
      const f = new a.Color(s);
      u?.color.set(f), c?.color.set(f);
    },
    onCommit: (s, f) => {
      const g = t.applySnap(s, f.clientX, f.clientY);
      if (e.current.closed) {
        e.current = { points: [g], hoverWorld: g, closed: !1 }, w();
        return;
      }
      C(g), e.current.points.length >= 3 && N();
    },
    onMove: (s) => {
      e.current.closed || e.current.points.length < 1 || (e.current = { points: e.current.points, hoverWorld: s, closed: !1 }, w());
    },
    onKeyDown: (s) => {
      if (s.key === "Escape") {
        (e.current.points.length > 0 || e.current.closed) && (s.preventDefault(), s.stopPropagation()), R(!0);
        return;
      }
      if (s.key === "Backspace") {
        if (re(s.target)) return;
        !e.current.closed && e.current.points.length >= 1 && (s.preventDefault(), m());
      }
    },
    reset: R
  });
  const l = (s) => {
    o = s;
  }, x = () => {
    e.current = ee(), w();
  };
  return {
    attach: t.attach,
    detach: t.detach,
    setEnabled: t.setEnabled,
    setUnits: l,
    setColor: t.setColor,
    clear: x,
    dispose: t.dispose
  };
}
function lt(r, e) {
  if (!Number.isFinite(r)) return "—";
  if (e === "rad")
    return `${(r * Math.PI / 180).toFixed(3)} rad`;
  if (e === "dms") {
    const t = r < 0 ? "-" : "", o = Math.abs(r);
    let u = Math.floor(o), c = Math.floor((o - u) * 60), h = Math.round(((o - u) * 60 - c) * 60);
    return h === 60 && (h = 0, c += 1), c === 60 && (c = 0, u += 1), `${t}${u}°${c.toString().padStart(2, "0")}'${h.toString().padStart(2, "0")}"`;
  }
  return `${r.toFixed(1)}°`;
}
const He = ["endpoint", "midpoint", "center", "quadrant", "node"];
function it(r) {
  let e = null;
  const t = (b) => {
    e !== b && (e = b, r?.(b));
  };
  let o = null, u = null, c = null, h = () => ({ x: 0, y: 0, z: 0 }), y = null, p = null, D = null, P = !1, w = ke, R = "#ff6b1a", N = null, C = null, m = null;
  const l = /* @__PURE__ */ new Map();
  let x = Number.NaN, s = Number.NaN, f = null, g = !1;
  const k = () => {
    !u || C || (C = new a.Group(), C.name = "dxf-snap-overlay", C.renderOrder = de, C.visible = !1, u.add(C), m = new a.LineBasicMaterial({
      color: new a.Color(R),
      depthTest: !1,
      depthWrite: !1,
      transparent: !0,
      opacity: 1
    }), M("endpoint", Ue()), M("midpoint", Ve()), M("center", Ke()), M("quadrant", je()), M("node", $e()));
  }, M = (b, n) => {
    if (!C || !m) return;
    const E = b === "node" ? new a.LineSegments(n, m) : new a.LineLoop(n, m);
    E.visible = !1, E.renderOrder = de, C.add(E), l.set(b, E);
  }, B = () => {
    if (!o || !c) return 1;
    const b = o.getBoundingClientRect();
    if (b.width === 0) return 1;
    const n = new a.Vector3(0, 0, 0).unproject(c), E = new a.Vector3(2 / b.width, 0, 0).unproject(c), L = n.distanceTo(E);
    return L > 0 && Number.isFinite(L) ? L : 1;
  }, O = () => {
    e === null && (!C || !C.visible) || (C && (C.visible = !1), t(null), y?.());
  }, i = (b, n) => {
    if (k(), !C) return;
    const E = h();
    C.position.set(b.point.x - E.x, b.point.y - E.y, 0);
    const L = n * Be;
    C.scale.set(L, L, 1);
    for (const [G, _] of l) _.visible = G === b.type;
    C.visible = !0, t(b.type), y?.();
  }, d = (b, n, E) => {
    if (!P || !p || !D)
      return O(), b;
    if (g && b.x === x && b.y === s)
      return f ? f.point : b;
    x = b.x, s = b.y, g = !0;
    const L = B(), G = L * w, _ = Re(p, D, b, G, {
      types: He,
      visibleLayers: N
    });
    return f = _, _ ? (i(_, L), _.point) : (O(), b);
  }, I = (b, n, E, L, G) => {
    o = b, u = n, c = E, h = L, y = G, k();
  }, A = (b, n) => {
    p = b, D = n, W();
  }, S = (b) => {
    P !== b && (P = b, b || O(), W());
  }, T = (b) => {
    R = b, m?.color.set(b), y?.();
  }, Y = (b) => {
    Number.isFinite(b) && b > 0 && (w = b);
  }, X = (b) => {
    N = b, W();
  }, W = () => {
    x = Number.NaN, s = Number.NaN, f = null, g = !1;
  };
  return {
    attach: I,
    setData: A,
    setEnabled: S,
    setColor: T,
    setTolerance: Y,
    setVisibleLayers: X,
    resolve: d,
    clear: () => {
      O(), W();
    },
    dispose: () => {
      u && C && u.remove(C);
      for (const b of l.values())
        b.geometry?.dispose();
      l.clear(), m?.dispose(), C = null, m = null, o = null, u = null, c = null, y = null, p = null, D = null, P = !1, e = null;
    }
  };
}
function K(r) {
  const e = new Float32Array(r.length * 3);
  for (let o = 0; o < r.length; o++)
    e[o * 3] = r[o][0], e[o * 3 + 1] = r[o][1], e[o * 3 + 2] = 0;
  const t = new a.BufferGeometry();
  return t.setAttribute("position", new a.BufferAttribute(e, 3)), t;
}
function Ue() {
  return K([
    [-0.5, -0.5],
    [0.5, -0.5],
    [0.5, 0.5],
    [-0.5, 0.5]
  ]);
}
function Ve() {
  return K([
    [0, 0.6],
    [-0.55, -0.4],
    [0.55, -0.4]
  ]);
}
function je() {
  return K([
    [0.6, 0],
    [0, 0.6],
    [-0.6, 0],
    [0, -0.6]
  ]);
}
function Ke() {
  const e = [];
  for (let t = 0; t < 24; t++) {
    const o = t / 24 * Math.PI * 2;
    e.push([Math.cos(o) * 0.55, Math.sin(o) * 0.55]);
  }
  return K(e);
}
function $e() {
  return K([
    [-0.5, -0.5],
    [0.5, 0.5],
    [-0.5, 0.5],
    [0.5, -0.5]
  ]);
}
function te(r, e, t) {
  return r === "window" ? "window" : r === "crossing" ? "crossing" : t.x >= e.x ? "window" : "crossing";
}
function qe(r, e, t, o) {
  return {
    x: Math.min(r.x, e.x) - t.left,
    y: Math.min(r.y, e.y) - t.top,
    width: Math.abs(e.x - r.x),
    height: Math.abs(e.y - r.y),
    mode: o
  };
}
function Qe(r, e) {
  return {
    minX: Math.min(r.x, e.x),
    minY: Math.min(r.y, e.y),
    maxX: Math.max(r.x, e.x),
    maxY: Math.max(r.y, e.y)
  };
}
function at(r) {
  let e = null, t = null, o = null, u = null, c = { x: 0, y: 0 }, h = null, y = "shift", p = "auto", D = !1, P = !1, w = {}, R = null, N = !1, C = null;
  const m = (n) => y === "shift" ? n.shiftKey : y === "ctrl" ? n.ctrlKey || n.metaKey : y === "alt" ? n.altKey : !1, l = (n) => y === "shift" ? n.key === "Shift" : y === "ctrl" ? n.key === "Control" || n.key === "Meta" : y === "alt" ? n.key === "Alt" : !1, x = (n, E) => {
    if (!e || !t) return null;
    const L = e.getBoundingClientRect(), G = (n - L.left) / L.width * 2 - 1, _ = -((E - L.top) / L.height) * 2 + 1, z = new a.Vector3(G, _, 0).unproject(t);
    return { x: z.x + c.x, y: z.y + c.y };
  }, s = (n) => {
    e && (e.style.cursor = n ? "crosshair" : "");
  }, f = () => {
    C !== null || !o || (C = o.enabled, o.enabled = !1);
  }, g = () => {
    C !== null && (N || R || (o && (o.enabled = C), C = null));
  }, k = (n) => {
    if (D) {
      if (n.key === "Escape" && R) {
        I();
        return;
      }
      l(n) && (N || (N = !0, s(!0), f()));
    }
  }, M = (n) => {
    D && l(n) && N && (N = !1, s(!1), g());
  }, B = (n) => {
    D && n.button === 0 && m(n) && (R = { x: n.clientX, y: n.clientY }, f());
  }, O = (n, E) => {
    if (!R || !e) return;
    const L = e.getBoundingClientRect(), G = te(p, R, { x: n });
    r(
      qe(R, { x: n, y: E }, { left: L.left, top: L.top }, G)
    );
  }, i = (n) => {
    if (!D || !R) return;
    const E = n.clientX - R.x, L = n.clientY - R.y;
    if (!(!P && Math.hypot(E, L) < oe)) {
      if (!P) {
        P = !0;
        const G = te(p, R, { x: n.clientX, y: n.clientY });
        w.onStart?.(G);
      }
      O(n.clientX, n.clientY);
    }
  }, d = (n) => {
    if (!D || !R) return;
    if (!P) {
      A();
      return;
    }
    const E = x(R.x, R.y), L = x(n.clientX, n.clientY);
    if (!E || !L) {
      A();
      return;
    }
    const G = te(p, R, { x: n.clientX, y: n.clientY }), _ = u ? Te(u, Qe(E, L), { mode: G }) : [], z = h === null ? _ : _.filter((H) => h.has(H.layer));
    w.onSelect?.(z, G), w.onEnd?.(), A();
  }, I = () => {
    R && (w.onCancel?.(), w.onEnd?.(), A());
  }, A = () => {
    R = null, P = !1, r(null), g();
  };
  return {
    attach: (n, E, L, G) => {
      e = n, t = E, o = L, w = G, D = !0, e.addEventListener("pointerdown", B), window.addEventListener("pointermove", i), window.addEventListener("pointerup", d), window.addEventListener("keydown", k), window.addEventListener("keyup", M);
    },
    detach: () => {
      D = !1, e && (e.removeEventListener("pointerdown", B), s(!1)), window.removeEventListener("pointermove", i), window.removeEventListener("pointerup", d), window.removeEventListener("keydown", k), window.removeEventListener("keyup", M), N = !1, A(), e = null, t = null, o = null, w = {};
    },
    installRectData: (n, E) => {
      u = n, c = E;
    },
    removeRectData: () => {
      u = null, A();
    },
    setEnabled: (n) => {
      D = n, n || (N = !1, s(!1), A());
    },
    setModifier: (n) => {
      y = n, N = !1, s(!1);
    },
    setMode: (n) => {
      p = n;
    },
    setVisibleLayers: (n) => {
      h = n;
    }
  };
}
const Ze = 16;
function ct() {
  let r = null, e = null, t = null, o = [], u = /* @__PURE__ */ new Map(), c = null, h = null, y = null, p = null, D = null;
  const P = new a.Raycaster(), w = new a.Vector2();
  let R = null, N = 0, C = 0, m = 0, l = !1;
  const x = (n, E, L) => {
    s(E), t = Ie(n), e = Ne(n), o = Oe(n), u = Je(o), r = Ge(t, L), E.add(r), r.updateMatrixWorld(!0);
  }, s = (n) => {
    const E = r;
    E && (n && n.remove(E), Xe(E), r = null), t = null, e = null, o = [], u = /* @__PURE__ */ new Map(), R = null;
  }, f = (n) => {
    if (!l || !r || !c || !h) return;
    const E = performance.now();
    if (E - N < Ze) return;
    N = E;
    const L = B(n.clientX, n.clientY), G = L?.handle ?? null;
    G !== R && (R = G, y?.(L));
  }, g = (n) => {
    l && (C = n.clientX, m = n.clientY);
  }, k = (n) => {
    if (!l || !p) return;
    const E = n.clientX - C, L = n.clientY - m;
    if (Math.hypot(E, L) > oe) return;
    const G = B(n.clientX, n.clientY);
    G && p(G);
  }, M = () => {
    l && R !== null && (R = null, y?.(null));
  }, B = (n, E) => {
    if (!r || !c || !h) return null;
    const L = c.getBoundingClientRect();
    w.x = (n - L.left) / L.width * 2 - 1, w.y = -((E - L.top) / L.height) * 2 + 1, P.setFromCamera(w, h);
    const G = r.visible;
    r.visible = !0;
    const _ = P.intersectObject(r, !0);
    if (r.visible = G, _.length === 0) return null;
    const z = D === null ? _ : _.filter((U) => {
      const V = U.object.userData.layerName;
      return V === void 0 || D.has(V);
    });
    if (z.length === 0) return null;
    let H = z[0], q = he(H.object), le = ge(H.object);
    for (let U = 1; U < z.length; U++) {
      const V = z[U].object, Z = he(V), ce = ge(V);
      (Z < q || Z === q && ce < le) && (H = z[U], q = Z, le = ce);
    }
    const me = H.object.userData.pickId, $ = H.object.userData.handle, ie = H.object.userData.dxfType, ve = H.object.userData.layerName;
    if (!$ || !ie) return null;
    const Q = e?.get($), ae = u.get($)?.[0];
    return {
      handle: $,
      pickId: me,
      type: ie,
      layer: ve ?? "0",
      text: ae?.text ?? (Q ? pe(Q) : void 0),
      entity: Q,
      association: ae
    };
  };
  return {
    installPickingData: x,
    removePickingData: s,
    attach: (n, E, L) => {
      c = n, h = E, y = L.onHover ?? null, p = L.onClick ?? null, l = !0, c.addEventListener("pointermove", f), c.addEventListener("pointerdown", g), c.addEventListener("pointerup", k), c.addEventListener("pointerleave", M);
    },
    detach: () => {
      l = !1, c && (c.removeEventListener("pointermove", f), c.removeEventListener("pointerdown", g), c.removeEventListener("pointerup", k), c.removeEventListener("pointerleave", M)), c = null, h = null, y = null, p = null;
    },
    setEnabled: (n) => {
      l = n;
    },
    setVisibleLayers: (n) => {
      D = n;
    },
    getPickingEntries: (n) => t?.byHandle.get(n) ?? [],
    getPickingEntryById: (n) => t?.byId.get(n),
    getPickingIndex: () => t,
    getEntityIndex: () => e,
    getAssociations: () => o,
    findAssociationsByHandle: (n) => u.get(n) ?? [],
    getPickingGroup: () => r,
    setDebug: (n) => {
      r && Fe(r, n);
    },
    buildEventForEntry: (n) => {
      const E = e?.get(n.handle), L = u.get(n.handle)?.[0];
      return {
        handle: n.handle,
        pickId: n.id,
        type: n.type,
        layer: n.layer,
        text: L?.text ?? (E ? pe(E) : void 0),
        entity: E,
        association: L
      };
    }
  };
}
function Je(r) {
  const e = /* @__PURE__ */ new Map();
  for (const t of r)
    for (const o of t.members) {
      const u = e.get(o);
      u ? u.push(t) : e.set(o, [t]);
    }
  return e;
}
function ge(r) {
  const e = r;
  e.geometry?.boundingBox || e.geometry?.computeBoundingBox();
  const t = e.geometry?.boundingBox;
  if (!t) return 1 / 0;
  const o = t.max.x - t.min.x, u = t.max.y - t.min.y, c = t.max.z - t.min.z;
  return o * u + o * c + u * c;
}
function he(r) {
  switch (r.userData.dxfType) {
    case "TEXT":
    case "MTEXT":
    case "ATTRIB":
    case "ATTDEF":
    case "DIMENSION":
    case "LEADER":
    case "MULTILEADER":
    case "MLEADER":
      return 1;
    case "LINE":
    case "CIRCLE":
    case "ARC":
    case "ELLIPSE":
    case "POINT":
    case "XLINE":
    case "RAY":
      return 2;
    case "POLYLINE":
    case "LWPOLYLINE":
    case "SPLINE":
    case "MLINE":
      return 3;
    case "SOLID":
    case "3DFACE":
      return 4;
    case "HATCH":
    case "INSERT":
      return 5;
    default:
      return 3;
  }
}
function ut() {
  let r = null, e = { x: 0, y: 0, z: 0 }, t = null, o = null, u = null, c = null;
  const h = (l, x, s) => {
    r = l, e = x, t || (t = new a.Group(), t.name = "dxf-highlight-group", t.renderOrder = 999, r.add(t)), o ? o.color.set(s) : o = new a.LineBasicMaterial({
      color: new a.Color(s),
      depthTest: !1,
      depthWrite: !1,
      transparent: !0,
      opacity: 0.95
    });
  }, y = (l, x) => {
    u = l, c = x;
  }, p = () => {
    u = null, c = null;
  }, D = (l) => {
    o?.color.set(l);
  }, P = (l) => {
    if (!(!t || !o)) {
      C();
      for (const x of l)
        w(x);
    }
  }, w = (l) => {
    if (l.type === "INSERT" && l.childIds?.length && c) {
      for (const f of l.childIds) {
        const g = c.byId.get(f);
        g && w(g);
      }
      return;
    }
    const x = u?.get(l.handle);
    if (!x) {
      N(l.bbox);
      return;
    }
    const s = _e(x, l.worldMatrix ?? null);
    if (s.fallbackToBBox) {
      N(l.bbox);
      return;
    }
    for (const f of s.polylines)
      R(f);
  }, R = (l) => {
    if (!t || !o || l.length < 2) return;
    const x = new Float32Array(l.length * 3);
    for (let g = 0; g < l.length; g++)
      x[g * 3] = l[g].x - e.x, x[g * 3 + 1] = l[g].y - e.y, x[g * 3 + 2] = l[g].z - e.z;
    const s = new a.BufferGeometry();
    s.setAttribute("position", new a.BufferAttribute(x, 3));
    const f = new a.Line(s, o);
    f.frustumCulled = !1, f.userData.isHighlight = !0, t.add(f);
  }, N = (l) => {
    if (!t || !o) return;
    const x = new a.Vector3();
    l.getSize(x);
    const s = new a.Vector3();
    l.getCenter(s);
    const f = Math.max(x.x, 0.01), g = Math.max(x.y, 0.01), k = Math.max(x.z, 0.01), M = new a.BoxGeometry(f, g, k), B = new a.EdgesGeometry(M);
    M.dispose();
    const O = new a.LineSegments(B, o);
    O.position.set(
      s.x - e.x,
      s.y - e.y,
      s.z - e.z
    ), O.frustumCulled = !1, O.userData.isHighlight = !0, t.add(O);
  }, C = () => {
    if (t)
      for (const l of [...t.children])
        (l instanceof a.Line || l instanceof a.LineSegments) && l.geometry.dispose(), t.remove(l);
  };
  return {
    init: h,
    installHighlightData: y,
    removeHighlightData: p,
    setColor: D,
    highlight: P,
    clear: C,
    dispose: () => {
      C(), t && r && r.remove(t), t = null, o && (o.dispose(), o = null), r = null, u = null, c = null;
    }
  };
}
export {
  Qe as buildWorldRect,
  st as createAngleMeasurementController,
  rt as createAreaMeasurementController,
  ut as createHighlightController,
  tt as createMeasurementController,
  ct as createPickingController,
  se as createPointerTool,
  at as createRectangleSelectionController,
  it as createSnapController,
  j as ensurePositionCapacity,
  lt as formatAngleValue,
  ot as formatAreaValue,
  nt as formatMeasureValue,
  We as isPanGesture,
  re as isTypingTarget,
  qe as normaliseScreenRect,
  te as resolveSelectionMode,
  ne as screenToWorldPoint,
  ze as worldPerPixel,
  Ye as worldToScreenPoint
};
